import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '../../../@core/data/general.service';

export interface ModalDialogButton {
  label: string;
  style: 'primary' | 'outline';
  action: 'confirm' | 'dismiss';
}

@Component({
  selector: 'edm-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalDialogComponent {

  @Input() icon: string = '';
  @Input() image: string = '';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttons: ModalDialogButton[] = [];

  closeLabel: string;

  constructor(
    private activeModal: NgbActiveModal,
    private generalService: GeneralService,
  ) {
    this.closeLabel = this.generalService.getTranslate('timeline.modules.closeLabel');
  }

  onButton(button: ModalDialogButton): void {
    if (button.action === 'confirm') {
      this.activeModal.close(true);
    } else {
      this.activeModal.dismiss();
    }
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
